import React from 'react'
import blueapp from "../../../assets/images/appstore_blue.png"
import blue from "../../../assets/images/googleplay_blue.png"
import Bredcrumb from '../../Bredcrumb/Main'
import BGImg from "../../../assets/images/bread_crumb_bg.png"
import BGImg1 from "../../../assets/images/bread_crumb_bg_one.png"
import BGImg2 from "../../../assets/images/bread_crumb_bg_two.png"
import Faq from '../../HomeMain/Faq/Main'
import screen from '../../../assets/images/download-screen01.png'
import screen1 from '../../../assets/images/download-screen02.png'

const Main = ({brdcum}) => {
  return (
    <>
        {brdcum.b1 && 
        <Bredcrumb 
            no={1}
            title="Have questions? look here" 
            paragraph="Learn more about myFit  through answers to frequently asked questions."
            tag="Faq" 
            bgimg={BGImg}/>}

        {brdcum.b2 && 
        <Bredcrumb 
            no={2}
            title="Have questions? look here" 
            paragraph="Learn more about myFit  through answers to frequently asked questions."
            tag="Faq" 
            bgimg={BGImg1}/>}

        {brdcum.b5 && 
        <Bredcrumb 
        no={5}
        title="Have questions? look here" 
        paragraph="Learn more about myFit  through answers to frequently asked questions."
        tag="Faq" 
        bgimg={BGImg}/>}

        {brdcum.b3 && 
        <Bredcrumb 
            no={3}
            title="Have questions? look here" 
            paragraph="Learn more about myFit  through answers to frequently asked questions."
            tag="Faq" />}

        {brdcum.b4 && 
        <Bredcrumb 
            no={4}
            title="Have questions? look here" 
            paragraph="Learn more about myFit  through answers to frequently asked questions."
            tag="Faq" 
            bgimg={BGImg2}/>}

        <Faq />

        <section className="row_am free_app_section review_freeapp" id="getstarted">
            <div className="container">
                <div className="free_app_inner aos-init" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="100"> 
                    <div className="anim_line dark_bg">
                        <span><img src="assets/images/anim_line.png" alt="anim_line" /></span>
                        <span><img src="assets/images/anim_line.png" alt="anim_line" /></span>
                        <span><img src="assets/images/anim_line.png" alt="anim_line" /></span>
                        <span><img src="assets/images/anim_line.png" alt="anim_line" /></span>
                        <span><img src="assets/images/anim_line.png" alt="anim_line" /></span>
                        <span><img src="assets/images/anim_line.png" alt="anim_line" /></span>
                        <span><img src="assets/images/anim_line.png" alt="anim_line" /></span>
                        <span><img src="assets/images/anim_line.png" alt="anim_line" /></span>
                        <span><img src="assets/images/anim_line.png" alt="anim_line" /></span>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="free_text">
                                <div className="section_title">
                                    <h2>Let’s download free from apple and play store</h2>
                                    <p>Instant free download from apple and play store. All you need is an iPhone or Android device to enjoy all personalized metrics for personal use. Welcome to myFit App.</p>
                                </div>
                                <ul className="app_btn">
                                    <li>
                                        <a href={process.env.REACT_APP_ANDROID_URL}>
                                        <img src={blueapp} alt="image" />
                                        </a>
                                    </li>
                                    <li>
                                        <a href={process.env.REACT_APP_IOS_URL}>
                                        <img src={blue} alt="image" />
                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="free_img">
                                <img src={screen} alt="image" />
                                <img className="mobile_mockup" src={screen1} alt="image" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Main